import React from "react";
import { Search } from "lucide-react";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";
import { Input } from "modules/common/components/ui/Input";
import { cn } from "utils/utils";

interface MapSearchAutocompleteSkeletonProps {
  className?: string;
}

const MapSearchAutocompleteSkeleton: React.FC<
  MapSearchAutocompleteSkeletonProps
> = ({ className }) => {
  return (
    <div className={cn("relative", className)}>
      <Input
        layout="horizontal"
        className="w-full"
        placeholder="In which city do you play?"
        aria-label="Search for a city"
        aria-hidden
        tabIndex={-1}
        disabled
        startContent={<Search size={ICON_SIZE} />}
      />
    </div>
  );
};

export default MapSearchAutocompleteSkeleton;
